let pending = false;
const listeners = new Set();
export function setSignupProvisioning(value) {pending = value; listeners.forEach(listener => listener());}
export const getSignupProvisioning = () => pending;
export function subscribeSignupProvisioning(listener) {listeners.add(listener); return () => listeners.delete(listener);}
